import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  inputFeild: {
    width: "80%"
  }
}))